<div class="dialog-container vd-dialog" [formGroup]="form">
  <!-- Header -->
  <div class="dialog-header">
    <div class="user-edit-icon">
      <!-- <i class="{{ details.image[0] }}" [style]="details.image[1]"></i> -->
      <i *ngIf="deviceIcon(details?.systemId) as icon; else deviceImg" [class]="icon" aria-hidden="true"></i>
      <ng-template #deviceImg><img [src]="details.image" alt="{{details.title}}" class="device-img"/></ng-template>
    </div>
    <div class="header-text">
      <h2 style="font-weight: 600;">Log {{ details.title }}</h2>
    </div>
    <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg">
    <!-- <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <!-- Form Content (same fields, validators and handlers as before; only the presentation is modernized) -->
  <form (ngSubmit)="onSubmit()" class="dialog-content" [formGroup]="form">
    <!-- Non-BP Fields -->
    <div class="vd-field" *ngIf="categoryType !== 'Blood Pressure'">
      <label class="vd-label" for="rd-value1">Reading ({{ valueUnit1 }}) <span class="vd-req" aria-hidden="true">*</span></label>
      <input id="rd-value1" class="vd-input" type="number" [placeholder]="'Enter ' + details?.title" formControlName="value1"
             maxlength="3" [min]="0" [class.is-invalid]="showError('value1')" [attr.aria-invalid]="showError('value1') ? true : null"
             (input)="getChange('value1')" (keypress)="preventNonNumeric($event)" (paste)="preventPasteNonNumeric($event)" />
      <div class="vd-error" role="alert" *ngIf="showError('value1')">
        <span *ngIf="form.controls['value1'].hasError('required')">This field is required</span>
        <span *ngIf="form.controls['value1'].hasError('min')">Value must be greater than 10</span>
        <span *ngIf="form.controls['value1'].hasError('max')">Value must be less than 999</span>
      </div>
    </div>

    <!-- Blood Glucose: when did you check? -->
    <div class="vd-field" *ngIf="categoryType=='Blood Glucose'">
      <span class="vd-label" id="rd-meal-label">When did you check?</span>
      <div class="vd-meals" role="group" aria-labelledby="rd-meal-label">
        <button type="button" class="vd-meal" *ngFor="let meal of mealTypes"
                [class.is-selected]="selectedMeal === meal.key" [attr.aria-pressed]="selectedMeal === meal.key"
                (click)="selectMeal(meal)">
          <img [src]="meal.icon" alt="" class="vd-meal-icon" />
          <span class="vd-meal-label">{{ meal.label }}</span>
        </button>
      </div>
    </div>

    <!-- Blood Pressure Fields -->
    <ng-container *ngIf="categoryType === 'Blood Pressure'">
      <div class="vd-row">
        <div class="vd-field">
          <label class="vd-label" for="rd-value1">Systolic ({{ valueUnit1 }}) <span class="vd-req" aria-hidden="true">*</span></label>
          <input id="rd-value1" class="vd-input" type="number" placeholder="Enter Systolic" formControlName="value1" maxlength="3" [min]="0"
                 [class.is-invalid]="showError('value1')" [attr.aria-invalid]="showError('value1') ? true : null"
                 (input)="getChange('value1')" (keypress)="preventNonNumeric($event)" (paste)="preventPasteNonNumeric($event)" />
          <div class="vd-error" role="alert" *ngIf="showError('value1')">
            <span *ngIf="form.controls['value1'].hasError('required')">This field is required</span>
            <span *ngIf="form.controls['value1'].hasError('min')">Value must be greater than 10</span>
            <span *ngIf="form.controls['value1'].hasError('max')">Value must be less than 999</span>
          </div>
        </div>
        <div class="vd-field">
          <label class="vd-label" for="rd-value2">Diastolic ({{ valueUnit2 }}) <span class="vd-req" aria-hidden="true">*</span></label>
          <input id="rd-value2" class="vd-input" type="number" placeholder="Enter Diastolic" formControlName="value2" maxlength="3" [min]="0"
                 [class.is-invalid]="showError('value2')" [attr.aria-invalid]="showError('value2') ? true : null"
                 (input)="getChange('value2')" (keypress)="preventNonNumeric($event)" (paste)="preventPasteNonNumeric($event)" />
          <div class="vd-error" role="alert" *ngIf="showError('value2')">
            <span *ngIf="form.controls['value2'].hasError('required')">This field is required</span>
            <span *ngIf="form.controls['value2'].hasError('min')">Value must be greater than 10</span>
            <span *ngIf="form.controls['value2'].hasError('max')">Value must be less than 999</span>
          </div>
        </div>
      </div>
      <div class="vd-field">
        <label class="vd-label" for="rd-value3">Pulse ({{ valueUnit3 }}) <span class="vd-req" aria-hidden="true">*</span></label>
        <input id="rd-value3" class="vd-input" type="number" placeholder="Enter Pulse" formControlName="value3" maxlength="3" [min]="0"
               [class.is-invalid]="showError('value3')" [attr.aria-invalid]="showError('value3') ? true : null"
               (input)="getChange('value3')" (keypress)="preventNonNumeric($event)" (paste)="preventPasteNonNumeric($event)" />
        <div class="vd-error" role="alert" *ngIf="showError('value3')">
          <span *ngIf="form.controls['value3'].hasError('required')">This field is required</span>
          <span *ngIf="form.controls['value3'].hasError('min')">Value must be greater than 10</span>
          <span *ngIf="form.controls['value3'].hasError('max')">Value must be less than 999</span>
        </div>
      </div>
    </ng-container>

    <!-- Date/Time -->
    <div class="vd-row">
      <div class="vd-field">
        <label class="vd-label" for="rd-date">Date <span class="vd-req" aria-hidden="true">*</span></label>
        <div class="vd-input-wrap">
          <input id="rd-date" class="vd-input vd-input--date" [matDatepicker]="picker" [max]="maxDate" formControlName="readingDate" readonly
                 placeholder="Select date" (focus)="picker.open()" (click)="picker.open()" />
          <mat-datepicker-toggle class="vd-date-toggle" [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div class="vd-field">
        <label class="vd-label" for="rd-time">Time <span class="vd-req" aria-hidden="true">*</span></label>
        <div class="vd-input-wrap">
          <img src="assets/images/health/icons/Frame 1000004270.svg" class="vd-time-icon" alt="" />
          <input id="rd-time" class="vd-input vd-input--time" type="time" formControlName="readingTime"
                 [value]="form.controls.readingTime.value" />
        </div>
      </div>
    </div>

    <!-- Comment -->
    <div class="vd-field">
      <label class="vd-label" for="rd-comment">Add More Details (Optional) (Optional)</label>
      <textarea id="rd-comment" class="vd-input vd-textarea" rows="2" formControlName="comment" placeholder="Type here..."></textarea>
    </div>

    <!-- Actions -->
    <div class="dialog-actions">
      <button type="button" class="vd-btn vd-btn--secondary" (click)="onCancel()">Cancel</button>
      <button type="submit" class="vd-btn vd-btn--primary">Save</button>
    </div>
  </form>
</div>